<div class="bg-card p-0 m-0">
  <div class="flex items-center justify-content-between" mat-dialog-title>
    <mat-icon class="me-2" [svgIcon]="givenIcon || 'heroicons_solid:academic-cap'"></mat-icon>
    <h2 class="text-2xl font-bold">{{ title }}</h2>
  </div>
  <mat-divider class="mb-5"></mat-divider>

  <div mat-dialog-content class="flex flex-col gap-5 align-center overflow-hidden">
    <div class="text-secondary text-lg leading-normal">
      <p [innerHTML]="message"></p>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end">
    <button
      *ngIf="confirmData"
      mat-raised-button
      color="primary"
      class="mat-dense"
      id="continue"
      (click)="onConfirm()"
    >
      {{ confirmData | transloco }}
    </button>
    <button (click)="onDismiss()" class="mat-dense" id="close" mat-raised-button>
      {{ closeBtnText ? closeBtnText : ('Close' | transloco) }}
    </button>
  </div>
</div>
